/// <summary>
/// 日志打印相关
/// </summary>

import Util from "@/Master/Util";

/// <author>xiexingwu</author>
export default class KitLog {
    static LogTag: string = "<SDK>";

    private static _IsLog: boolean = false;

    public static get IsLog(): boolean {
        if (!KitLog._IsLog) {
            KitLog._IsLog = Util.isSdkLog;
        }
        return KitLog._IsLog;
    }

    /// <summary>
    /// 打印日志Log级别
    /// </summary>
    /// <param name="isForceLog">是否强制打印，默认false，走测试开关</param>
    /// <param name="messages">消息数组</param>
    public static Log(...messages: string[]) {
        if (KitLog.IsLog) {
            console.log(KitLog.LogTag, messages);
        }
    }

    public static LogForce(...messages: string[]) {
        console.log(KitLog.LogTag, messages);
    }

    public static LogWarning(...messages: string[]) {
        if (KitLog.IsLog) {
            console.warn(KitLog.LogTag, messages);
        }
    }

    public static LogWarningForce(...messages: string[]) {
        console.warn(KitLog.LogTag, messages);
    }

}
